import { ConfigProvider, Form, Row, Table } from 'antd';
import classNames from 'classnames/bind';
import styles from './ComboServiceBooking.module.scss';

import { SVGS } from '~/assets/assetsPath';
import EmptyForm from '../Empty';

const cx = classNames.bind(styles);

const ComboServiceBooking = ({
    userComboServiceList,
    setUserComboServiceList,
    setComboServiceSelected,
    setIsShowComboServiceList,
}) => {
    const columns = [
        {
            title: (text, record, tabIndex) => {
                return <div style={{ fontSize: '16px', fontWeight: '600', color: '#311d4f' }}>Service</div>;
            },
            width: '50%',
            render: (text, record, index) => (
                <div
                    style={{
                        fontWeight: '600',
                    }}
                >
                    {record?.service?.title}
                </div>
            ),
        },
        {
            title: () => {
                return <div style={{ fontSize: '16px', fontWeight: '600', color: '#311d4f' }}>Remaining</div>;
            },
            align: 'center',
            width: '25%',
            render: (text, record, index) => (
                <div
                    style={{
                        color: 'rgba(137, 137, 137, 1)',
                    }}
                >
                    {record?.available_times_temp}
                </div>
            ),
        },
        {
            title: () => {
                return <div style={{ fontSize: '16px', fontWeight: '600', color: '#311d4f' }}>Select</div>;
            },
            align: 'center',
            width: '25%',
            render: (text, record, index) => (
                <Row justify="center" align="middle">
                    <div className={cx('button_count')} onClick={() => decreaseAmount(record)}>
                        <img src={SVGS.IconSub} alt="" />
                    </div>
                    <span className={cx('count')}>{record?.amount_order}</span>
                    <div className={cx('button_count')} onClick={() => increaseAmount(record)}>
                        <img src={SVGS.IconPlus} alt="" />
                    </div>
                </Row>
            ),
        },
    ];
    const increaseAmount = (item) => {
        let comboServiceList = userComboServiceList;
        for (const comboService of comboServiceList) {
            for (const comboUsing of comboService?.combo_using) {
                if (
                    comboUsing.service_id === item.service_id &&
                    comboService.combo_service_id === item.combo_service_id &&
                    comboService.id === item.order_item_id
                ) {
                    if (comboUsing.amount_order < comboUsing.available_times) {
                        comboUsing.amount_order++;
                        comboUsing.available_times_temp--;
                    }
                    break;
                }
            }
        }
        setUserComboServiceList([...comboServiceList]);
    };
    const decreaseAmount = (item) => {
        let comboServiceList = userComboServiceList;
        for (const comboService of comboServiceList) {
            for (const comboUsing of comboService?.combo_using) {
                if (
                    comboUsing.service_id === item.service_id &&
                    comboService.combo_service_id === item.combo_service_id &&
                    comboService.id === item.order_item_id
                ) {
                    if (comboUsing.amount_order > 0) {
                        comboUsing.amount_order--;
                        comboUsing.available_times_temp++;
                    }
                    break;
                }
            }
        }
        setUserComboServiceList([...comboServiceList]);
    };

    const handleAgreeComboServiceBooking = () => {
        let selected = [];
        for (const comboService of userComboServiceList) {
            for (const comboUsing of comboService?.combo_using) {
                if (comboUsing.amount_order > 0) {
                    comboUsing.combo_service_title = comboService.title;
                    selected.push(comboUsing);
                }
            }
        }
        setComboServiceSelected([...selected]);
        setIsShowComboServiceList(false);
    };

    return (
        <Form className={cx('wrapper_combo_booking')}>
            <Form.Item>
                <Row justify="center" className={cx('name_page')}>
                    Purchased service packages
                </Row>
            </Form.Item>
            <Form.Item>
                {userComboServiceList?.length ? (
                    <>
                        {userComboServiceList?.map((item) => {
                            return (
                                <Row className={cx('row_item_combo')} key={item.id}>
                                    <span className={cx('name_combo')}>{item?.title}</span>
                                    <ConfigProvider renderEmpty={() => <EmptyForm />}>
                                        <Table
                                            className={cx('table')}
                                            columns={columns}
                                            dataSource={item?.combo_using}
                                            pagination={false}
                                            style={{ width: '100%' }}
                                        //   loading={isLoading}
                                        />
                                    </ConfigProvider>
                                </Row>
                            );
                        })}
                        <Row justify="center">
                            <div className={cx('btn_agree')} onClick={handleAgreeComboServiceBooking}>
                                Confirm
                            </div>
                        </Row>
                    </>
                ) : (
                    <div className={cx('no_service')}>
                        <img src={SVGS.IconNoService} alt="" />
                        <span>No service pack yet</span>
                    </div>
                )}
            </Form.Item>
        </Form>
    );
};

export default ComboServiceBooking;
